import {Action} from "@ngrx/store";

export const LOAD_CACHE_EXCLUDE: string = '[info] Load CacheExclude';
export const LOAD_CACHE_EXCLUDE_SUCCESS: string = '[info] Load CacheExclude Success';
export const LOAD_CACHE_EXCLUDE_FAIL: string = '[info] Load CacheExclude Fail';

export class LoadCacheExclude implements Action {
  readonly type: string = LOAD_CACHE_EXCLUDE;
  constructor(public payload: number) {}
}

export class LoadCacheExcludeSuccess implements Action {

  readonly type: string = LOAD_CACHE_EXCLUDE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[websiteId: number]: any},
  }) {}

}

export class LoadCacheExcludeFail implements Action {

  readonly type: string = LOAD_CACHE_EXCLUDE_FAIL;
  constructor(public payload: string) {}

}


export type CacheExcludeAction = LoadCacheExclude | LoadCacheExcludeSuccess | LoadCacheExcludeFail;
